export default ({
    status: ['In Progress', 'Future', 'Open', 'Complete', 'Cancelled', 'Error'],
    orderTypes: ['All', 'Curbside', 'Online', 'Walk up', 'Call in', 'Kiosk', 'Scan to pay', 'POS', 'Table', 'Tab'],
});